import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id 3D34BFA8-56E0-4FDB-A8CF-7C19AFE14277
 * name store-alert-outline
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-alert-outline.svg
 * tags
 * - Places 
 * - Shopping 
 * - Alert / Error 
 */
export const StoreAlertOutlineIcon = createSvgIcon(<><path d="M2 7L1 12V14H2V20H12V14H16V20H18V14H19V12L18 7H2M10 18H4V14H10V18M3.04 12L3.64 9H16.36L16.96 12H3.04M18 6H2V4H18V6M23 7V13H21V7H23M21 15H23V17H21V15Z" /></>, 'StoreAlertOutlineIcon');
export default StoreAlertOutlineIcon